"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Input = _interopRequireDefault(require("../Input"));

var _hooks = require("../../hooks");

var _excluded = ["className", "onChange", "externalValue"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.5 20.5l-6-6m2-4.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
  }));
};

SearchIcon.defaultProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#17181A"
};

// TODO: this is desktop only component
var InputFilter = function InputFilter(_ref, ref) {
  var className = _ref.className,
      onChange = _ref.onChange,
      externalValue = _ref.externalValue,
      inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(externalValue),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    setValue(externalValue);
  }, [externalValue]);
  var debouncedValue = (0, _hooks.useDebounce)(value, 900);
  (0, _hooks.useDidUpdate)(function () {
    return onChange(debouncedValue);
  }, [debouncedValue]);
  return /*#__PURE__*/_react["default"].createElement(StyledInputFilter, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledInput, (0, _extends2["default"])({}, inputProps, {
    ref: ref,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(StyledSearchIcon, null));
};

var inactiveColor = 'greyLight';
var activeColor = 'blackBase';
var StyledSearchIcon = (0, _styledComponents["default"])(SearchIcon).withConfig({
  displayName: "InputFilter__StyledSearchIcon",
  componentId: "sc-yehnzd-0"
})(["position:absolute;left:10px;top:50%;transform:translateY(-50%);width:14px;height:14px;stroke-width:1;stroke:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors[inactiveColor];
});
var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "InputFilter__StyledInput",
  componentId: "sc-yehnzd-1"
})(["width:100%;height:37px;padding:10px;padding-left:30px;border-radius:2px;border:solid 1px;background:transparent;font-size:14px;border-color:", ";", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors[inactiveColor];
}, function (_ref4) {
  var theme = _ref4.theme;
  return (0, _styledComponents.css)(["&:hover,&:focus{border-color:", ";+ ", "{stroke:", ";}}&:focus{background-color:", ";}"], theme.colors[activeColor], StyledSearchIcon, theme.colors[activeColor], theme.colors.white);
});

var StyledInputFilter = _styledComponents["default"].div.withConfig({
  displayName: "InputFilter__StyledInputFilter",
  componentId: "sc-yehnzd-2"
})(["position:relative;"]);

InputFilter.propTypes = _objectSpread(_objectSpread({}, _Input["default"].propTypes), {}, {
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired
});
InputFilter.defaultProps = {
  className: '',
  defaultValue: ''
};

var _default = /*#__PURE__*/_react["default"].memo(InputFilter);

exports["default"] = _default;